import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectOperationPage } from './select-operation';
import { DailyLogPageModule } from '../../daily-log/daily-log/daily-log.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    SelectOperationPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectOperationPage),
    DailyLogPageModule,
    FoundationModule,
    DirectivesModule,
  ],
})
export class SelectOperationPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/select-operation/select-operation.module.ts